var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3141 0H7.82529C6.81556 0 7.18018 0.67315 7.48871 1.00972C11.6398 5.10472 20.2112 13.6145 21.2883 14.8934C22.4663 16.6605 21.4566 17.7543 20.9517 18.764C20.5478 19.5718 20.8115 20.3067 21.0359 20.6994C21.12 20.7835 21.1705 21.0696 22.3821 21.8774C23.5938 22.6851 24.9065 21.9896 25.4113 21.5408C26.8698 20.1103 29.9551 17.0643 30.6282 16.3239C31.3014 15.5834 30.9087 14.8373 30.6282 14.5569C26.0845 10.0692 16.9128 0.992896 16.5762 0.589006C16.2397 0.185116 15.5946 0.0280479 15.3141 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6859 31.7571L23.1747 31.7571C24.1844 31.7571 23.8198 31.0839 23.5113 30.7474C19.3602 26.6524 10.7888 18.1426 9.71172 16.8636C8.53371 15.0966 9.54343 14.0028 10.0483 12.993C10.4522 12.1853 10.1885 11.4504 9.96415 11.0577C9.88001 10.9736 9.82952 10.6875 8.61785 9.87971C7.40618 9.07193 6.09354 9.76752 5.58868 10.2163C4.13019 11.6467 1.04492 14.6927 0.371767 15.4332C-0.301383 16.1737 0.0912889 16.9197 0.371766 17.2002C4.91553 21.6879 14.0872 30.7642 14.4238 31.1681C14.7603 31.572 15.4054 31.729 15.6859 31.7571Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAdmin);
export default __webpack_public_path__ + "static/media/logo-admin.df4cd0673f38466c3046ca0d4c3c3c9d.svg";
export { ForwardRef as ReactComponent };